var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9504 4.67741L18.1365 3.4913C18.7916 2.83623 19.8536 2.83623 20.5087 3.4913C21.1638 4.14637 21.1638 5.20844 20.5087 5.86351L14.8939 11.4783C14.0094 12.3628 13.5672 12.805 13.0283 13.1061C12.4894 13.4073 11.2168 13.7103 10 14C10.2897 12.7832 10.5927 11.5106 10.8939 10.9717C11.195 10.4328 11.6372 9.99054 12.5217 9.10606L16.9504 4.67741Z",
    stroke: "#242428",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.5H9C5.68629 4.5 3 7.18629 3 10.5V14C3 17.3137 5.68629 20 9 20H15C18.3137 20 21 17.3137 21 14V11",
    stroke: "#242428",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewChat);
export default __webpack_public_path__ + "static/media/icon-new-chat.ea893182e7fdb78fdd0924f4436a1a93.svg";
export { ForwardRef as ReactComponent };